import API from "@/services/api";
import { ComerOrigin } from "../types/comerOrigin";

export enum Endpoints {
  GasLeadComers = "/gas/leads/comers",
  LeadComers = "/leads/comers"
}

const fetchLeadComers = (
  gas: boolean = false
) => {
  return new Promise<ComerOrigin[]>(async (resolve, reject) => {
    API.get<ComerOrigin[]>({
      endpoint: gas ? Endpoints.GasLeadComers : Endpoints.LeadComers,
      versions: [gas ? 2 : 1]
    })
    .then(res => {
      resolve(res.promise.data)
    })
    .catch(err => {
      reject(err);
    })
  })
}


export default {
  fetchLeadComers
};